import { createFileRoute } from '@tanstack/react-router';
import { SemanticsPage } from '@/pages/SemanticsPage';

export const Route = createFileRoute('/_authed/semantics')({
  component: SemanticsPage,
});
